import React, { useEffect, useState } from 'react';
import { Container, Loader, Message } from 'semantic-ui-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { loginByKakao } from '../api/UserApi';

const KakaoLoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState('');

  const code = new URLSearchParams(location.search).get('code');

  useEffect(() => {
    if (!code) {
      setError('카카오 인가 코드가 없습니다.');
      return;
    }

    const doLogin = async () => {
      try {
        const result = await loginByKakao(code);
        if (result && result.errorCode === 0) {
          // TODO: 토큰 저장 및 관리자 메인 페이지로 이동
          // result.response에 UserAccessTokenDto가 들어있음
          navigate('/main/dashboard');
        } else {
          setError('카카오 로그인에 실패했습니다.');
        }
      } catch (e) {
        setError('카카오 로그인 처리 중 오류가 발생했습니다.');
      }
    };

    doLogin();
  }, [code, navigate]);

  return (
    <Container text style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {!error ? (
        <Loader active inline="centered" size="large">
          카카오 로그인 중...
        </Loader>
      ) : (
        <Message negative>
          <Message.Header>카카오 로그인 실패</Message.Header>
          <p>{error}</p>
        </Message>
      )}
    </Container>
  );
};

export default KakaoLoginPage;
